import { useFormikContext } from 'formik'

import withForm from 'lib/formik/with-form'
import useValidatedSave from 'lib/formik/use-validated-save'
import { ProbateEstate } from 'lib/models/probate-estate'
import { ANY_OTHER_NOTES_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import Section from '../components/section'
import useSectionToggle from '../use-section-toggle'

type HandleSave = (event: { name: string; value: unknown }) => void

type Props = {
  probateEstate: ProbateEstate
  saveProbateEstateField: HandleSave
}

const NOTES_NAME = 'notesNotCoveredElsewhere'

const AnyOtherNotes = ({ probateEstate, saveProbateEstateField }: Props) => {
  const { values } = useFormikContext<Record<string, unknown>>()

  const handleSave = useValidatedSave({
    schema: ANY_OTHER_NOTES_SCHEMA,
    save: saveProbateEstateField,
  })

  // there's no column for this toggle: it starts on if there's a note, and
  // staff can turn it on to add one. Nothing is saved when it's switched
  const toggle = useSectionToggle({
    name: 'anyOtherNotesActive',
    initialValue: !!probateEstate.attributes[NOTES_NAME],
    save: () => undefined,
  })

  return (
    <Section
      heading="4.5 Any other notes"
      notesName={NOTES_NAME}
      onNotesSave={handleSave}
      toggle={{ ...toggle, disabled: !!values[NOTES_NAME] }}
    />
  )
}

const AnyOtherNotesForm = withForm(AnyOtherNotes)

const AnyOtherNotesSection = (props: Props) => (
  <AnyOtherNotesForm
    initialValues={{
      [NOTES_NAME]: props.probateEstate.attributes[NOTES_NAME] ?? null,
    }}
    validationSchema={ANY_OTHER_NOTES_SCHEMA}
    {...props}
  />
)

export default AnyOtherNotesSection
